export function removeEmptyCommas(string: string) {
  const newStr = string
    .split(',')
    .filter((item) => item.trim() !== '')
    .join(', ');

  return newStr;
}
